import { FocusManagerLock } from '@features/canvas/services/FocusManager/FocusManager.types';

export function getFocusManagerLockExpirationTime(expirationTime: number) {
  return Date.now() + expirationTime;
}

export function isFocusManagerLockExpired(lock: FocusManagerLock) {
  return lock.expiry && lock.expiry < Date.now();
}
